const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || 'http://localhost:4000/api').replace(/\/+$/, '');
const OTP_API_PATH = String(process.env.REACT_APP_OTP_API_PATH || 'otp_delete').replace(/^\/+/, '');
export const OTP_API_URL = `${API_BASE_URL}/${OTP_API_PATH}`;
const TOKEN_KEY = 'authToken';
const ADMIN_KEY = 'admin';
const BRANCH_KEY = 'selected_branch_id';

let fetchPatched = false;

function readJsonFromStorage(key) {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

function parseBranchId(value) {
  const n = Number(value);
  if (!Number.isInteger(n) || n <= 0) return null;
  return n;
}

export const apiUrl = (path = '') => {
  const cleanPath = String(path || '').replace(/^\/+/, '');
  return cleanPath ? `${API_BASE_URL}/${cleanPath}` : API_BASE_URL;
};

export const getStoredAdmin = () => readJsonFromStorage(ADMIN_KEY);

export const getStoredToken = () => String(localStorage.getItem(TOKEN_KEY) || '').trim();

export const getSelectedBranchId = () => {
  const admin = getStoredAdmin();
  if (!admin) return null;

  if (String(admin.role || '') === 'branch_admin') {
    return parseBranchId(admin.branch_id);
  }

  const selected = parseBranchId(localStorage.getItem(BRANCH_KEY));
  if (selected) return selected;

  const active = parseBranchId(admin.active_branch_id);
  if (active) return active;

  const list = Array.isArray(admin.allowed_branches) ? admin.allowed_branches : [];
  for (const b of list) {
    const id = parseBranchId(b?.id);
    if (id) return id;
  }
  return null;
};

export const setSelectedBranchId = (branchId) => {
  const parsed = parseBranchId(branchId);
  if (!parsed) return;
  localStorage.setItem(BRANCH_KEY, String(parsed));
};

export const clearAuthState = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(ADMIN_KEY);
  localStorage.removeItem(BRANCH_KEY);
};

export const installApiFetchInterceptor = () => {
  if (fetchPatched || typeof window === 'undefined' || typeof window.fetch !== 'function') {
    return;
  }

  const nativeFetch = window.fetch.bind(window);
  window.fetch = (input, init = {}) => {
    const requestUrl = typeof input === 'string' ? input : String(input?.url || '');
    const isApi = requestUrl.startsWith(API_BASE_URL);
    if (!isApi) {
      return nativeFetch(input, init);
    }

    const headers = new Headers(init.headers || (input instanceof Request ? input.headers : undefined));
    const token = getStoredToken();
    const branchId = getSelectedBranchId();

    if (token && !headers.has('Authorization')) {
      headers.set('Authorization', `Bearer ${token}`);
    }
    if (branchId && !headers.has('x-branch-id')) {
      headers.set('x-branch-id', String(branchId));
    }

    if (input instanceof Request) {
      const nextRequest = new Request(input, { ...init, headers });
      return nativeFetch(nextRequest);
    }

    return nativeFetch(input, { ...init, headers });
  };

  fetchPatched = true;
};

export default API_BASE_URL;
